import React from 'react'
import type { HitlabelContextType } from '@hitlabel.jp/main-site/types'

export const HitlabelContext = React.createContext<HitlabelContextType | null>(null)
export const HitlabelProvider = HitlabelContext.Provider
